import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Breadcrumbs,
  Link,
  List,
  ListItem,
  ListItemText,
  useTheme,
} from '@mui/material';
import { Home, AutoAwesome } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const CustomSolutionsPage = () => {
  const theme = useTheme();

  const sections = [
    {
      title: "Tailored Stone Solutions for Every Space",
      content: [
        "At Mall of Stone, we believe stone is more than a material — it is an expression of elegance and permanence. From private residences to landmark commercial projects, our custom solutions are designed to translate vision into timeless spaces."
      ]
    },
    {
      title: "Custom Stone Selection",
      content: [
        "Choose from an exclusive range of marble, granite, quartz, sandstone, and engineered stones, customized by:",
        "Color and natural veining",
        "Dimensions and thickness",
        "Surface finish — polished, honed, matte, or textured",
        "Patterns, layouts, and bespoke design detailing"
      ]
    },
    {
      title: "AI-Powered Recommendations",
      content: [
        "Our intelligent system analyzes your space requirements, budget range, and functional needs such as slip resistance, durability, and water exposure — delivering stone recommendations curated precisely for your project."
      ]
    },
    {
      title: "Visual Matching & Design Assistance",
      content: [
        "Upload images of your space for visually aligned stone suggestions",
        "Preview textures in real-world environments",
        "Receive expert-curated recommendations for modern, classic, or luxury interiors"
      ]
    },
    {
      title: "Made-to-Measure Craftsmanship",
      content: [
        "We offer precision cutting and finishing for:",
        "Kitchen countertops",
        "Bathroom vanities",
        "Staircases and feature walls",
        "Outdoor patios and architectural elements",
        "Each piece is crafted to exact specifications with uncompromising attention to detail."
      ]
    },
    {
      title: "Tailored for Signature Projects",
      content: [
        "Perfectly suited for:",
        "Luxury residences and private villas",
        "Boutique hotels and resorts",
        "High-end commercial and retail spaces",
        "We ensure consistency, quality matching, and seamless execution — even at scale."
      ]
    },
    {
      title: "A White-Glove Experience",
      content: [
        "From consultation to delivery, our process is designed to feel effortless:",
        "Personalized expert guidance",
        "Rigorous quality assurance",
        "Premium packaging and handling",
        "Dedicated post-delivery support",
        "Because true luxury lies in precision and ease."
      ]
    },
    {
      title: "Why Mall of Stone",
      content: [
        "Mall of Stone redefines how luxury stone is discovered and experienced. By combining premium materials, intelligent technology, and expert craftsmanship, we deliver bespoke solutions that offer confidence, consistency, and timeless elegance — crafted for spaces that demand distinction."
      ]
    }
  ];

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>

        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          {/* <Typography color="text.primary">Custom Solutions</Typography> */}
        </Breadcrumbs>

        {/* Header */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Paper
            sx={{
              p: 4,
              mb: 4,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              color: 'white',
              textAlign: 'center',
            }}
          >
            <AutoAwesome sx={{ fontSize: 60, mb: 2, opacity: 0.9,color:'white' }} />
            <Typography variant="h3" fontWeight="bold" sx={{color:'white'}}>
              Custom Stone Solutions
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto', mt: 1 ,color:'white'}}>
              Bespoke stone experiences crafted for refined living and architectural excellence.
            </Typography>
          </Paper>
        </motion.div>

        {/* Sections */}
        {sections.map((section, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 * index }}
          >
            <Paper sx={{ p: 4, mb: 3 }}>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ color: 'primary.main', mb: 2 }}
              >
                {section.title}
              </Typography>
              <List>
                {section.content.map((item, i) => (
                  <ListItem key={i} sx={{ px: 0 }}>
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </motion.div>
        ))}
      </Container>
    </Box>
  );
};

export default CustomSolutionsPage;
